/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CallDealerModal_item = {
    readonly serviceId: string | null;
    readonly title: string | null;
    readonly " $refType": "CallDealerModal_item";
};
export type CallDealerModal_item$data = CallDealerModal_item;
export type CallDealerModal_item$key = {
    readonly " $data"?: CallDealerModal_item$data;
    readonly " $fragmentRefs": FragmentRefs<"CallDealerModal_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CallDealerModal_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '8a0622c8f30902723b719505e0e1dab5';
export default node;
